module.exports = __webpack_public_path__ + "img/homeIlustration.036cf9fe.png";